<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-comment</v-icon>
      <h2 class="title ml-2">Agregar notificación</h2>
    </v-card-title>
    <v-card-text>
      <v-form ref="notificacion">
        <v-text-field
          v-model="notificacion.titulo"
          label="Título"
          :error-messages="errTitulo"
        ></v-text-field>
        <v-text-field
          v-model="notificacion.contenido"
          label="Mensaje"
          :error-messages="errContenido"
        ></v-text-field>
        <v-text-field
          v-model="notificacion.fecha"
          label="Fecha"
          type="datetime-local"
          :error-messages="errFecha"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
      <v-btn color="primary" @click="saveNotificacion()" :loading="loading">
        <v-icon left>fas fa-save</v-icon>
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      loading: false,
      notificacion: {
        titulo: '',
        contenido: '',
        fecha: '',
        enviado: false
      }
    }
  },
  computed: {
    errTitulo () {
      const errs = []
      if (!this.$v.notificacion.$dirty) return errs
      !this.$v.notificacion.titulo.required && errs.push('El título es requerido')
      return errs
    },
    errContenido () {
      const errs = []
      if (!this.$v.notificacion.contenido.$dirty) return errs
      !this.$v.notificacion.contenido.required && errs.push('El mensaje es requerido')
      return errs
    },
    errFecha () {
      const errs = []
      if (!this.$v.notificacion.fecha.$dirty) return errs
      !this.$v.notificacion.fecha.required && errs.push('La es requerida')
      return errs
    }
  },
  methods: {
    async saveNotificacion () {
      this.$v.notificacion.$touch()
      if (!this.$v.notificacion.$invalid) {
        this.loading = true
        try {
          await this.$http.notificaciones.post('', this.notificacion)
          this.$refs.notificacion.reset()
          this.$v.notificacion.$reset()
          this.$emit('saved')
          this.loading = false
        } catch (error) {
          this.loading = false
          window.alert('Ha ocurrido un error')
        }
      }
    }
  },
  validations: {
    notificacion: {
      titulo: { required },
      contenido: { required },
      fecha: { required }
    }
  }
}
</script>
